module.exports = __webpack_public_path__ + "static/media/banner-img-team.d7cc9d25.png";